import React from 'react';

import BookCover from './BookCover';

import { formatDate, formatTime, formatNumberWithSpaces, formatHumanTime } from './helpers.js';

const PhoneAssignment = ({ taskType, dueDate, selectedChapters, numWords, numMinutes, book, instructions }) => {

    const totalDuration = selectedChapters.reduce((sum, chapter) => sum + chapter.duration, 0);
    const totalTokens = selectedChapters.reduce((sum, chapter) => sum + chapter.tokens, 0);
    const chaptersSummary = [
        totalDuration > 0 ? formatTime(totalDuration) : false,
        totalTokens > 0 ? formatNumberWithSpaces(totalTokens, 'words') : false
    ].filter(x => x).join(', ');

    return (
        <div className="phone-assignment-container">
            <div className="assignment-card" >
                <div style={{ fontWeight: 500, marginTop: 10 }}>next assignment</div>
                <div style={{ fontWeight: 500, fontSize: '130%', color: 'white', backgroundColor: '#93DC9A', padding: '6px 20px', borderRadius: 10, margin: 20, whiteSpace: 'nowrap' }}>by {formatDate(dueDate)}</div>
                {taskType === 'text' && selectedChapters && selectedChapters.length > 0 ? <>
                    {selectedChapters.map((chapter, index) =>
                        <div key={index} style={{ color: "#60c", fontSize: '140%', textTransform: 'none', textAlign: 'center' }}>{chapter.title}</div>
                    )}
                    <div style={{ marginBottom: 20 }}>({chaptersSummary})</div>
                </> : ( numWords > 0 ?
                    <>
                        <div style={{ marginBottom: 5 }}>Read at least</div>
                        <div style={{ color: "#60c", fontSize: '140%' }}>{formatNumberWithSpaces(numWords, 'words')}</div>
                        <div style={{ marginTop: 5 }}>in any text</div>
                    </> : <>
                        <div style={{ marginBottom: 5 }}>Study any text for</div>
                        <div style={{ color: "#60c", fontSize: '140%' }}>{formatHumanTime(numMinutes * 60)}</div>
                    </>
                )}
                { taskType === 'text' && book && <>
                    <BookCover large url={book.cover} />
                    <div style={{ fontWeight: 400, marginTop: 10, fontSize: '80%', textAlign: 'center' }}>{book.author}</div>
                    <div style={{ fontWeight: 400, fontSize: '80%', textAlign: 'center' }}>{book.title}</div>
                </>}
                {instructions && <>
                    <div style={{ fontWeight: 500, fontSize: '120%', color: "#60c", width: '100%', marginTop: 20, marginBottom: 10 }}>Instructions</div>
                    <div style={{ fontWeight: 400, fontSize: '120%', width: '100%', textTransform: 'none' }}>
                        {instructions.split(/\n+/g).map((p, i) => <p key={i}>{p}</p>)}
                    </div>
                </>}
            </div>
        </div>
    );

};

export default PhoneAssignment;
